import {ObjectUtil} from '../util/object-util';

export class GeoLocation {
 lat: string = null;
 lng: string = null;

  constructor(object: any) {
    ObjectUtil.assign(this, object);
  }
}
